import { ERROR_CODES } from '../constants/error-codes';
import {
  AuthorizationError,
  BadRequestError,
  CodeSyntaxError,
  NotFoundError,
  ServiceUnavailableError,
} from './errors';
import { LANGUAGE_CONSTANTS as LANG_CONST } from '../constants/language-constants';
import { TranslateService } from '@ngx-translate/core';

export const checkGenericErrors = (type: string, translate: TranslateService) => {
  if (type.includes(ERROR_CODES.ERROR_REQUEST_FOUND)) {
    throw new CodeSyntaxError(translate.instant('SERVER_NOT_ABLE_PERFORM_REQUEST'));
  } else if (type.includes(ERROR_CODES.ERROR_REQUEST_UNAUTHORIZED)) {
    throw new CodeSyntaxError(translate.instant('SERVER_UNAUTHORIZED_REQUEST'));
  } else if (type.includes(ERROR_CODES.ERROR_REQUEST_IMAGE_UPLOAD)) {
    throw null; // S3 Image is uploading but throwing the error from the backend hence we have kept it null.
  } else if (type.includes(ERROR_CODES.ERROR_REQUEST_NETWORK_ISSUE)) {
    throw new CodeSyntaxError(translate.instant('UNABLE_TO_CONNECT_INTERNET'));
  }
  switch (type) {
    case ERROR_CODES.SyntaxError:
      throw new CodeSyntaxError(
        translate.instant('INVALID_REQUESTED_DATA_List_OF_SITES')
      );
    case ERROR_CODES.NULL_VALUE:
      throw new NotFoundError(translate.instant('YOUR_PROVIDED_FIELDS_HAS_NULL_VALUE'));
    case ERROR_CODES.BAD_ARGUMENT:
      throw new BadRequestError(translate.instant('YOU_PROVIDED_BAD_ARGUMENT'));
    case ERROR_CODES.LIMIT_EXCEED:
      throw new BadRequestError(translate.instant('YOUR_RETRY_LIMIT_HAS_EXCEEDED'));
    case ERROR_CODES.INTERNAL_SERVER_ERROR:
      throw new ServiceUnavailableError(
        translate.instant('SERVICE_IS_NOT_AVAILABLE_PLEASE_TRY_LATER'),
        ERROR_CODES.INTERNAL_SERVER_ERROR
      );
    case ERROR_CODES.USER_NOT_AUTHORIZED:
      throw new AuthorizationError(
        translate.instant('YOU_ARE_NOT_AUTHORIZED_TO_MAKE_THIS_CALL')
      );
    case ERROR_CODES.BAD_REQUEST_EXCEPTION:
      throw new BadRequestError(translate.instant('YOUR_REQUEST_IS_NOT_CORRECT'));
  }
};
